// ProcedureTable.jsx (Aligned: Removed internal pagination to sync with modal; kept search/filter/CSV as features)
import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from "react";
import axios from "axios";
import Select, { components } from "react-select";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faHospital,
  faShieldAlt,
  faSearch,
  faArrowRight,
  faSpinner,
  faExclamationTriangle,
  faInfoCircle,
  faTimes,
  faCheckCircle,
  faChevronDown,
  faEye,
  faUserMd,
  faStethoscope,
  faClipboard,
  faPlusCircle,
  faStethoscope as faConsultIcon,
  faUserInjured as faInpatientIcon,
  faBandage as faOutpatientIcon,
  faVial as faDiagnosticIcon,
  faPlay,
  faBan,
  faXmark,
  faFileCsv,
  faMinusCircle,
  faVial,
} from "@fortawesome/free-solid-svg-icons";
import Papa from "papaparse"; // For CSV export

// Updated Procedure Table: Removed internal pagination (handled by parent modal); kept search/filter/CSV
const ProcedureTable = ({
  procedures,
  onRemove,
  onEditRate,
  providerId,
  ratesData,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCategory, setFilterCategory] = useState("all");

  useEffect(()=>{
    console.log(procedures)
  },[])


  const filteredProcedures = useMemo(() => {
    let filtered = procedures.filter(
      (proc) =>
        proc?.cpt?.cpt_desc?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        proc?.cpt?.cpt_code?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    );

    if (filterCategory !== "all") {
      filtered = filtered.filter(
        (proc) => proc.cpt.cpt_categ_code === filterCategory
      );
    }

    return filtered;
  }, [procedures, searchTerm, filterCategory]);

  const handleExportCSV = () => {
    const csvData = procedures.map((proc) => ({
      "CPT Code": proc.cpt.cpt_code,
      Description: proc.cpt.cpt_desc,
      Category: proc.cpt.cpt_categ_code,
      Rate: proc.rate,
    }));
    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "procedures.csv";
    link.click();
  };

  return (
    <div className="space-y-4">
      {/* Controls */}
      <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
        <input
          type="text"
          placeholder="Search procedures..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-md flex-1 max-w-md"
        />
        <Select
          placeholder="Filter by Category"
          value={{
            value: filterCategory,
            label: filterCategory === "all" ? "All Categories" : filterCategory,
          }}
          onChange={(opt) => setFilterCategory(opt.value)}
          options={[
            { value: "all", label: "All Categories" },
            ...Array.from(
              new Set(procedures.map((p) => p.cpt.cpt_categ_code))
            ).map((cat) => ({ value: cat, label: cat })),
          ]}
          className="w-full md:w-48"
          isSearchable={false}
        />
        <button
          onClick={handleExportCSV}
          className="px-4 py-2 bg-green-600 text-white rounded-md flex items-center gap-2 hover:bg-green-700"
        >
          <FontAwesomeIcon icon={faFileCsv} />
          Export CSV
        </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                CPT Code
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Description
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Category
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Rate (₱)
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredProcedures.map((proc, idx) => (
              
              <tr key={idx} className="border-t">
                <td className="px-4 py-2">{proc.cpt.cpt_code}</td>
                <td className="px-4 py-2">{proc.cpt.cpt_desc}</td>
                <td className="px-4 py-2">{proc.cpt.cpt_categ_code}</td>
                <td className="px-4 py-2">
                  <input
                    type="number"
                    value={proc.rate}
                    onChange={(e) =>
                      onEditRate(idx, parseFloat(e.target.value) || 0)
                    }
                    className="w-24 px-2 py-1 border border-gray-300 rounded"
                    step="0.01"
                    min="0"
                  />
                </td>
                <td className="px-4 py-2">
                  <button
                    onClick={() => onRemove(idx)}
                    className="text-red-600 hover:text-red-800"
                  >
                    <FontAwesomeIcon icon={faMinusCircle} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* No procedures message */}
      {filteredProcedures.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          No procedures match the filter.
        </div>
      )}
    </div>
  );
};

export default ProcedureTable;